import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PageClean from '../default/PageClean';
import SweetAlert from 'react-bootstrap-sweetalert';
import Alert from '../../components/Alert';
import moment from 'moment';
import { getCustomerPlan, updatePlanEnd } from '../../actions/ActionCustomer';

const CustomerPlanEndEditModal = ({
  fnOnClose = () => {},
  fnOnSubmit = () => {},
  nCustId,
}) => {
  const [bIsLoading, setIsLoading] = useState(true);
  const [bIsSubmitting, setIsSubmitting] = useState(false);
  const [aErrors, setErrors] = useState([]);
  const [bOpenConfirmModal, setOpenConfirmModal] = useState(false);

  const [oCustomer, setCustomer] = useState({});
  const [cReason, setReason] = useState('');
  const [cDateEnd, setDateEnd] = useState('');

  const oDateBlockedMin = useMemo(() => moment().subtract(10, 'days'), []);

  const clearError = (cError) => {
    setErrors((aPrv) => aPrv.filter((cErr) => cErr !== cError));
  }

  const updateDateEnd = (date) => {
    if (date === null) return;
    date = moment(date).format('YYYY-MM-DD');
    setDateEnd(date);
  }

  const loadCustomerPlan = useCallback(async (nCustId) => {
    if (!bIsLoading) return;
    try {
      const oResult = await getCustomerPlan(nCustId);
      setCustomer(oResult.oCustomer);
      updateDateEnd(oResult.oCustomer.plan_dend);
    } catch (oError) {
      setErrors(['Erro ao carregar dados do cliente.']);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!nCustId) return;
    loadCustomerPlan(nCustId);
  }, []);

  const handleSubmit = async (evt, bConfirmed = false) => {
    if (evt) evt.preventDefault();
    if (bDisableSubmit) return;

    const oBody = { plan_dend: cDateEnd, alog_cdescription: cReason };

    // se for bloquear o cliente, pede confirmação
    if (!bConfirmed && moment(cDateEnd) < oDateBlockedMin) {
      setOpenConfirmModal(true);
      return;
    }
    setIsSubmitting(true);
    try {
      await updatePlanEnd(nCustId, oBody);
      setOpenConfirmModal(false);
      fnOnSubmit();
    } catch (oError) {
      setIsSubmitting(false);
      setErrors(oError.aMsgErrors);
    }
  };

  const handleClose = () => {
    fnOnClose();
  };

  const cInitialDate = useMemo(() => (oCustomer.plan_dend ? moment(oCustomer.plan_dend).format('YYYY-MM-DD') : ''), [oCustomer]);

  const bDisableSubmit = bIsSubmitting ||!cReason || !cDateEnd || cInitialDate === cDateEnd;

  return (
    <PageClean bLoading={bIsLoading}>
      {bOpenConfirmModal && (
        <ModalConfirm
          oCustomer={oCustomer}
          onConfirm={(evt) => handleSubmit(evt, true)}
          onCancel={() => setOpenConfirmModal(false)}
        />
      )}
      <form autoComplete="false" onSubmit={handleSubmit} className="form" style={{ paddingRight: '10px' }}>
        {aErrors.map((cError) => (
          <Alert
            key={cError}
            type="error"
            onCloseAlert={() => clearError(cError)}
          >
            {cError}
          </Alert>
        ))}
          <fieldset>
            <legend>Liberação</legend>

            <label className="split">
              <div>
                Vencimento atual:{' '}
                {oCustomer.plan_dend
                  ? moment.parseZone(oCustomer.plan_dend).format('DD/MM/YYYY')
                  : 'N/A'}
              </div>
            </label>

            <label className="split">
              Novo vencimento <span className="required">*</span>
              <input
                type="date"
                maxLength="250"
                value={cDateEnd}
                max={moment().add(1, 'year').add(6, 'month').format('YYYY-MM-DD')}
                onChange={evt => {
                  updateDateEnd(evt.target.value);
                }}
                required
              />
            </label>

            <label className="split">
              Motivo da alteração <span className="required">*</span>
              <textarea
                maxLength="255"
                className=""
                name="cReason"
                value={cReason}
                onChange={evt => setReason(evt.target.value)}
                required
              />
            </label>
          </fieldset>

          <div className="button-stack">
            <button
              type="button"
              className="btn alternate back btn btn-outline-secondary" title="Cancelar"
              onClick={handleClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={`btn btn-secondary${bDisableSubmit ? ' disabled' : ''}`}
              title="Salvar"
              disabled={bDisableSubmit}
            >
              Salvar
            </button>
          </div>
        </form>
    </PageClean>
  );
};

const ModalConfirm = ({ oCustomer, onConfirm, onCancel}) => {
  return (
    <SweetAlert
      warning
      showCancel
      confirmBtnText={'Confirma'}
      cancelBtnText={'Cancelar'}
      cancelBtnBsStyle="danger"
      title={''}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <p>
        Deseja realmente bloquear o cliente: {oCustomer.cust_cname}
        {' '}<span style={{fontWeight: 'bold', textWrap: "nowrap"}}>(ID: {oCustomer.cust_nid})</span>?
      </p>
    </SweetAlert>
  );
}

export default CustomerPlanEndEditModal;